/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Title_SignupInputs */



/**
* | output |
* | --- |
* | "Complete Signup" |
*
* @param {Auth_Verify_Title_SignupInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_verify_title_signup = /** @type {((inputs?: Auth_Verify_Title_SignupInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Title_SignupInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Finaliser l'inscription")
	if (locale === "es") return /** @type {LocalizedString} */ ("Completar registro")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Completar Cadastro")
	if (locale === "it") return /** @type {LocalizedString} */ ("Completa Registrazione")
	return /** @type {LocalizedString} */ ("Complete Signup")
});